/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { CandidateOppFeedAlertFrequency } from '../enums/candidate-opp-feed-alert-frequency';
export class CandidateOppFeedAlertEntity extends Entity {
  alertName: string | null = null;
  businessTitles: string[] | null = null;
  candidateId: string = '';
  countries: string[] | null = null;
  createdAt: string | null = null;
  engagementLengths: string[] | null = null;
  focusAreas: string[] | null = null;
  frequency: CandidateOppFeedAlertFrequency = null as unknown as never;
  id: string = '';
  industries: string[] | null = null;
  practiceAreas: string[] | null = null;
  updatedAt: string | null = null;
  weeklyCommitments: string[] | null = null;
  worksites: string[] | null = null;
  static override key = 'CandidateOppFeedAlert';
  static override schema = {};
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'CandidateOppFeedAlert' in input
    ) {
      const { CandidateOppFeedAlert: wrapped, ...rest } = input as {
        CandidateOppFeedAlert: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}